import { t } from '@/locales';

export default {
  APPLICATION_CONTEXTS: {
    SYSTEM_CONTEXT: 'system_context',
  },
  ENVIRONMENTS: {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production',
    /**
     * used by unit tests
     */
    TEST: 'test',
  },
  FEATURES_LIST: {
    ACTIVATE_DEACTIVATE_UNIT: 'ActivateDeactivateUnit',
    ACTIVATE_DEACTIVATE_UNIT_V2: 'ActivateDeactivateUnitV2',
    ADD_TRIP: 'TripLegandCopyV2',
    ADVANCE_PATIENT_SEARCH: 'AdvancePatientSearch',
    CALL_SOURCES: 'CallSources',
    CANCEL_TRIP: 'CancelTrip',
    CHANGE_PATIENT: 'ChangePatient',
    EDIT_PICKUP_TIME: 'EditPickupTime',
    EDIT_TIMESTAMPS: 'EditTimestamps',
    EXTERNAL_ID: 'ExternalId',
    GENDER_CODES: 'GenderCodes',
    LATE_REASONS: 'LateReasons',
    MISC_TIMESTAMPS: 'MiscTimeStamps',
    PATIENT_EDIT: 'EditPatient',
    PATIENT_NAME_SEARCH: 'PatientNameSearch',
    APPT_PU_REQ_TIMES: 'ApptPuReqTimes',
    REMOVE_PATIENT_SECTION: 'RemovePatientSection',
    SEND_UNIT_TO_POST: 'SendUnitToPost',
    TIME_FORMAT_WITH_SECONDS: 'TimeFormatWithSeconds',
    TRIP_NOTES: 'TripNotes',
    UNASSIGN_TRIP: 'UnassignTrip',
    UNIT_MESSAGE_REDESIGN: 'UnitMessageRedesign',
    TRIP_SEARCH: 'TripSearch',
    WILL_CALL: 'WillCall',
    ORDERING_FACILITY: 'OrderingFacility',
    FACILITY_SEARCH: 'FacilitySearch',
    ORDERING_PRACTITIONERS: 'OrderingPractitioners',
  },
  ZOOM_LEVEL: {
    MIN_LEVEL: 2,
    COUNTRY_LEVEL: 5,
    CITY_LEVEL: 10,
    STREET_LEVEL: 15,
    DEFAULT_LEVEL: 16,
    ZOOM_LEVEL_17: 17,
    AUTO_ZOOM_MAX_LEVEL: 18,
    ZOOM_LEVEL_21: 21,
    MAX_LEVEL: null,
  },
  LATLNGBOUNDS: {
    NORTH: 85,
    SOUTH: -85,
    EAST: 180,
    WEST: -180,
  },
  BAD_POSITION_VALUES: [0, -0, '0', '-0', '', null, undefined, NaN],
  NOTIFICATION_LEVEL: {
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    INFO: 'INFO',
    DEBUG: 'DEBUG',
  },
  CONFIGURATIONS: {
    ALLOW_MULTI_TRIP_ASSIGNMENT: 'ALLOW_MULTI_TRIP_ASSIGNMENT',
    BULK_RECOMMENDATIONS: 'BULK_RECOMMENDATIONS',
    UNIT: 'REQ_UNIT_ID',
    OPEN_WORK_LEAD_TIME: 'OPEN_WORK_LEAD_TIME',
    UNASSIGN_REASONS: 'UNASSIGN_REASONS',
    USE_METRIC: 'USE_METRIC',
    DEFAULT_CALL_SOURCE: 'TRIP_SOURCE_ORIGIN',
    PROQAENABLED: 'PROQAENABLED',
    DEFAULT_SORTING: {
      LANGUAGE: 'en-US-u-kn-true',
      ASC: 'asc',
      DESC: 'desc',
      OPTIONS: {
        CASE_FIRST: 'lower',
        NUMERIC: true,
        SENSITIVITY: 'base',
        USAGE: 'sort',
      },
    },
  },
  CALL_TAKING: {
    MODE: {
      EDIT: 'edit',
      CREATE: 'create',
    },
    ATTACHMENTS: {
      MAX_SIZE: 104857600, // 100 MB
      ALLOWED_TYPES: ['.pdf', '.docx', '.doc', '.jpeg', '.jpg'],
    },
  },
  START_MISC_TIMESTAMP: '12000',
  TRIPS: {
    BREADCRUMBS: {
      DEFAULT: '#9A709D',
      ASSIGNED: '#9A709D',
      WEATHER_CHECK: '#9A709D',
      EN_ROUTE: '#9A709D',
      AT_SCENE: '#9A709D',
      TRANSPORTING: '#9A709D',
      AT_DESTINATION: '#9A709D',
      PARTIALLY_AVAILABLE: '#9A709D',
    },
    WILL_CALL: {
      DEFAULT_WILL_CALL_TIME: '23:59:00',
    },
    TIMELINES_CONFIG: [
      {
        ID: '0',
        COMPONENT: 'ZoTimelineOpen',
      },
      {
        ID: '1',
        COMPONENT: 'ZoTimelineAssigned',
      },
      {
        ID: '2',
        COMPONENT: 'ZoTimelineEnRoute',
      },
      {
        ID: '3',
        COMPONENT: 'ZoTimelineLeg',
      },
      {
        ID: '4',
        COMPONENT: 'ZoTimelineTransporting',
      },
      {
        ID: '5',
        COMPONENT: 'ZoTimelineLeg',
      },
      {
        ID: '8',
        COMPONENT: 'ZoTimelinePreAssigned',
      },
      {
        ID: '101',
        COMPONENT: 'ZoTimelineOpen',
      },
      {
        ID: 'wheelsRolling',
        COMPONENT: 'ZoTimelineOutOfChute',
      },
      {
        ID: 'miscellaneous',
        COMPONENT: 'ZoTimelineSpecialTimeStamps',
      },
    ],
    TIMELINES: {
      WHEELSROLLING: 'wheelsrolling',
      MISCELLANEOUS: 'miscellaneous',
    },
    ACTIONS: {
      TIMESTAMPS: 'timestamps',
      UNASSIGN: 'unassign',
      COMPLETE: 'complete',
      CANCEL: 'cancel',
      ADDTRIP: 'addTrip',
    },
    ADD_TRIP_OPTIONS: {
      RETURN_TRIP: '1',
      ADD_LEG: '2',
      COPY_TRIP: '3',
      DUPLICATE_TRIP: '4',
      DUPLICATE_TRIP_WITH_ASSIGNMENT: '5',
    },
  },
  SEARCH: {
    TYPE: {
      API: 'api',
      FILTER: 'filter',
    },
  },
  VEHICLES: {
    STATUS: {
      INACTIVE: {
        NAME: 'disabled',
      },
    },
  },
  UI: {
    PANELS: {
      EMERGENCY_CALL: 'emergency',
      FULL_CALL: 'full',
    },
    TOKENS: {
      EMPTY: '::empty::',
      MAP_ID: 'the-map',
      HOPPER_ID: 'the-hopper',
      PAC_SELECTOR: '.pac-container',
    },
    CONTEXTS: {
      GLOBAL: '',
      ALERT: 'ALERT',
      SECURITY: 'SECURITY',
      CALL_TAKING: 'CALL_TAKING',
      DESTINATION_MODAL: 'DESTINATION_MODAL',
      DUPLICATE_TRIP: 'DUPLICATE_TRIP',
      DUPLICATE_TRIP_WITH_ASSIGNMENT: 'DUPLICATE_TRIP_WITH_ASSIGNMENT',
      EDIT_TIMESTAMP: 'EDIT_TIMESTAMP',
      LATE_REASONS: 'LATE_REASONS',
      PENDING_ASSIGNMENTS: 'PENDING_ASSIGNMENTS',
      SYSTEM_ALERT: 'SYSTEM_ALERT',
      BRIDGE_CONNECTION_ALERT: 'DISPATCH_SERVICE_ALERT',
      NETWORK: 'NETWORK',
      MAP_CONTROLS: 'MAP_CONTROLS',
      RESOURCE_LIST: 'RESOURCE_LIST',
      RECURRING_TRIP: 'RECURRING_TRIP',
      RECURRING_VIRTUAL_TRIP: 'RECURRING_VIRTUAL_TRIP',
      TRANSPORT_REQUEST: 'TRANSPORT_REQUEST',
      TRANSPORT_REQUEST_ACCEPT: 'TRANSPORT_REQUEST_ACCEPT',
      TRANSPORT_REQUEST_CANCEL: 'TRANSPORT_REQUEST_CANCEL',
      TRANSPORT_REQUEST_CANCEL_ACCEPT: 'TRANSPORT_REQUEST_CANCEL_ACCEPT',
      TRIP_DETAILS: 'TRIP_DETAILS',
      TRIP_NOTES: 'TRIP_NOTES',
      TRIP_NOTES_DELETE: 'TRIP_NOTES_DELETE',
      STATUS_CHANGER: 'CHANGE_STATUS',
      PATIENT_SEARCH: 'PATIENT_SEARCH',
      PATIENT_UPDATE: 'PATIENT_UPDATE',
      PATIENT_UPDATE_WITH_TRIP: 'PATIENT_UPDATE_WITH_TRIP',
      UNASSIGN_TRIP: 'UNASSIGN_TRIP',
      CANCEL_TRIP: 'CANCEL_TRIP',
      SPECIAL_TIMESTAMP: 'SPECIAL_TIMESTAMP',
      UNIT_UPDATE: 'UNIT_UPDATE',
      ACTIVATE_UNIT: 'ACTIVATE_UNIT',
      DEACTIVATE_UNIT: 'DEACTIVATE_UNIT',
      SHIFT_UPDATE: 'SHIFT_UPDATE',
      UNIT_POST_UPDATE: 'UNIT_POST_UPDATE',
      UNIT_AT_POST_UPDATE: 'UNIT_AT_POST_UPDATE',
      SPECIAL_STATUS_UPDATE: 'SPECIAL_STATUS_UPDATE',
      UNIT_AVAILABLE_UPDATE: 'UNIT_AVAILABLE_UPDATE',
      RESOURCES: 'RESOURCES',
    },
    ALERT_TYPES: {
      SUCCESS: 'success',
      INFO: 'info',
      CAUTION: 'caution',
      WARNING: 'warning',
      ERROR: 'error',
      NETWORK: 'network',
    },
    ERROR_PAGE_CODES: {
      DEFAULT: 'default',
      KNOWN: {
        AccessDenied: 'AccessDenied',
        UnauthorizedCompany: 'UnauthorizedCompany',
        UnauthorizedUser: 'UnauthorizedUser',
        NoCompanyConfig: 'NoCompanyConfig',
        NotInitialized: 'NotInitialized',
        MustBeCompanyAdmin: 'default',
        MustBeZollAdmin: 'default',
      },
    },
    FORM_VALIDATION_KEYS: {
      CALLER_NAME: 'c1CallerName',
      CALLER_ADDRESS_1: 'c2CallerAddress1',
      CALLER_ADDRESS_2: 'c3CallerAddress2',
      CALLER_PHONE_NUMBER: 'c4CallerPhoneNumber',
      CALLER_PHONE_EXTENSION: 'c5CallerPhoneExtension',
      CALLER_CALL_SOURCE: 'c6CallerCallSource',

      NATURE: 'f1Nature',
      CALL_TYPE: 'f2CallType',
      PRIORITY: 'f3Priority',

      PATIENT_LAST_NAME: 'i1PatientLastName',
      PATIENT_FIRST_NAME: 'i2PatientFirstName',
      PATIENT_SEX: 'i3PatientSex',
      PATIENT_AGE: 'i4PatientAge',
      PATIENT_DOB: 'i5PatientDob',
      PATIENT_ADDRESS_1: 'i6PatientAddress1',
      PATIENT_ADDRESS_2: 'i7PatientAddress2',
      PATIENT_PHONE_NUMBER: 'i8PatientPhoneNumber',
      PATIENT_PHONE_EXTENSION: 'i9PatientPhoneExtension',
      PATIENT_MIDDLE_NAME: 'i10PatientMiddleName',
      PATIENT_SSN: 'i11PatientSSN',
      PATIENT_SSN_EXIST: 'i12PatientSSN',
      PATIENT_WEIGHT: 'i13PatientWeight',

      PICK_UP_ADDRESS_1: 'l1PickUpAddress1',
      PICK_UP_ADDRESS_2: 'l2PickUpAddress2',
      PICK_UP_PHONE_NUMBER: 'l3PickUpPhoneNumber',
      PICK_UP_PHONE_EXTENSION: 'l4PickUpPhoneExtension',
      PICK_UP_DATE: 'l5PickUpDate',
      PICK_UP_TIME: 'l6PickUpTime',
      PICK_UP_DATE_MISMATCH: 'l7PickUpDate',
      PICK_UP_APPT_TIME: 'l8ApptTime',
      PICK_UP_REQUESTED_TIME: 'l9RequestedTime',
      PICK_UP_TIME_APPT_TIME_MISMATCH: 'l10PickUpTimeApptTime',

      UNIT_ASSIGNMENT: 'o1UnitAssignment',
      UNIT_UNIT: 'o2UnitUnit',
      UNIT_VEHICLE: 'o2UnitVehicle',
      UNIT_VEHICLE_TYPE: 'o2UnitVehicleType',
      UNIT_START_ODOMETER: 'o3UnitStartOdometer',
      UNIT_END_ODOMETER: 'o3UnitEndOdometer',
      UNIT_CREW_MEMBER_1: 'o4UnitCewMember1',
      UNIT_CREW_MEMBER_2: 'o4UnitCewMember2',
      UNIT_CREW_MEMBER_3: 'o4UnitCewMember3',

      DROP_OFF_ADDRESS_1: 'r1DropOffAddress1',
      DROP_OFF_ADDRESS_2: 'r2DropOffAddress2',
      DROP_OFF_PHONE_NUMBER: 'r3DropOffPhoneNumber',
      DROP_OFF_PHONE_EXTENSION: 'r4DropOffPhoneExtension',

      COMMENTS: 'u1Comments',
    },
    MARKER_CONTEXT: {
      ADDRESS: 'ADDRESS',
      CALL_TAKING: 'CALL_TAKING',
      DROP_OFF: 'DROP_OFF',
      GLOBAL_SEARCH: 'GLOBAL_SEARCH',
      LOCATION_INFO: 'LOCATION_INFO',
      PATIENT: 'PATIENT',
      PRACTITIONER: 'PRACTITIONER',
      PENDING_ASSIGNMENTS: 'PENDING_ASSIGNMENTS',
      PICK_UP: 'PICK_UP',
      TRIP_DETAILS: 'TRIP_DETAILS',
      TRIP_SEARCH: 'TRIP_SEARCH',
      RECURRING: 'RECURRING',
      SCHEDULER: 'SCHEDULER',
    },
    PATIENT_CONTEXT: {
      CALL_TAKING: 'CALL_TAKING',
      TRANSPORT_REQUEST: 'TRANSPORT_REQUEST',
      ALERT: 'ALERT',
    },
    HOTKEYS: {
      GLOBAL_SEARCH: 'G',
      EMERGENCY_CALL: 'E',
      FULL_CALL: 'T',
      UNIT_LIST: 'R',
      UNIT_LIST_FOCUS: 'U',
      PENDING_ASSIGNMENTS: 'P',
      MAP_LAYERS: 'L',
      ACTIVE_UNITS: 'A',
      RECURRING: 'C',
      TRIP_SEARCH: 'S',
      MAP_TOGGLE: 'M',
      ZOOM_OUT: 'O',
      ZOOM_IN: 'I',
      CALENDAR: 'D',
      ADD_ALERT: 'X',
      TRIP_REQUEST: 'R',
      SCHEDULER: 'H',
    },
  },
  RESPONSE_CODES: {
    SUCCESS: 'ZOLL.DISPATCH.SUCCESS',
    GENERAL_ERROR: 'ZOLL.DISPATCH.MAP.GENERAL_ERROR',
    NETWORK_OFFLINE: 'ZOLL.DISPATCH.MAP.NETWORK_OFFLINE',
    CONNECTION_ERROR: 'ZOLL.DISPATCH.MAP.CONNECTION_ERROR',
    USER_AUTH_ERROR: 'ZOLL.DISPATCH.MAP.USER_AUTH_ERROR',
    SEVERE_ERROR: 'ZOLL.DISPATCH.MAP.SEVERE_ERROR',
    BRIDGE_CONNECTION_ERROR: 'ZOLL.DISPATCH.MAP.BRIDGE_CONNECTION_ERROR',
  },
  FIXED_VALUES: {
    /**
     * the name of the cookie where ZO stores the JWT
     */
    JWT_COOKIE_NAME: 'ZOLLOnline_Token',
    SESSION_ID_COOKIE_NAME: 'dispatch_sessionid',
    MAX_AGE_IN_DAYS: 54787,
    MAX_ABS_LAT: 90,
    MAX_ABS_LNG: 180,
    UPDATE_DYNAMIC_PROPERTY_TIME: 60,
    CALLER_NAME_MAXLENGTH: 97,
    COMMENTS_MAXLENGTH: 2000,
    NOTES_MAXLENGTH: 2000,
    CANCEL_REASON_MAXLENGTH: 200,
    ODOMETER_MAXLENGTH: 10,
    ODOMETER_MAX_VALUE: 99999999.9,
    MAP_KEY_TYPE: {
      GLOBAL: 'global',
      CUSTOM: 'custom',
    },
    EXTERNAL_ID_MAXLENGTH: 25,
  },
  HACKS: {
    VALIDATION_TIMEOUT: 100,
    HOPPER_TIMEOUT: 100,
    MAP_ZOOM_TIMEOUT: 2000,
    APP_LOADING_TIMEOUT: 6500,
    CALL_TAKING_LOADING_TIMEOUT: 100,
    POPER_DISPLAY_TIME: 500,
  },
  DATA_VALUES: {
    DEFAULT_STRING: '<#>',
    SEX: {
      MALE: 'male',
      FEMALE: 'female',
      UNKNOWN: 'unknown',
    },
    DEFAULT_PATIENT_ID: '1',
    DEFAULT_PHONE: '000-000-0000',
    DEFAULT_SEX: '3', // <Unknown> value getting from RNDB
    DEFAULT_WEIGHT: '0.0',
    DEFAULT_WEIGHT_VAL: 0,
    DEFAULT_SSN: '000-00-0000',
    EMPTY_SEX: '0',
    EMPTY_SUFFIX: '0',
    DEFAULT_SUFFIX: '',
    YES: 'yes',
    PICK_UP_DATE: 'pickupDate',
    PICK_UP_TIME: 'pickupTime',
    PICK_UP_FULL_TIME: 'pickupFullTime',
    DOB: 'dateOfBirth',
    AGE: 'age',
    EXT: 'Ext.',
    CLEAR_ERRORS: 'clearErrors',
    NATURE: 'nature',
    CALL_SOURCE: 'caller.callSource',
    CALL_TYPE: 'callType',
    PRIORITY: 'priority',
    UNIT_Id: 'unitId',
    IS_UNIT_DEACTIVATED: 'isUnitDeactivated',
    UNKNOWN_FIRST_NAME: 'PATIENT',
    UNKNOWN_LAST_NAME: 'UNKNOWN',
    LBS: 'lbs',
    KGS: 'kgs',
    INVALID_DATE: 'Invalid Date',
    INVALID_DATE_TIME: 'Invalid DateTime',
    DEFAULT_FACILITY_ID: '1',
    MIN_YEARS: 150,
    MAX_YEARS: 150,
    TRIP_MIN_YEARS: 5,
    TRIP_MAX_YEARS: 5,
  },
  PATTERNS: {
    POSITIVE_NUMBERS: '^[0-9]*$',
    TIME: '[0-9]{2}:[0-9]{2}',
    DATE: '[0-9]{2}/[0-9]{2}/[0-9]{4}', // US or EU - same root numerical format
  },
  FORMATS: {
    TIME: 'HH:mm',
    FULL_TIME: 'HH:mm:ss',
    DATE: 'yyyy-MM-dd',
    LUXON_DATE: 'yyyy-MM-dd',
    DATE_DISPLAY_PATIENT: 'MM/dd/yyyy',
    DATE_TIME_WITHOUT_SECONDS: 'MM/dd/yyyy HH:mm',
    DATE_TIME_WITHOUT_SECONDS_WITH_COMMA: 'MM/dd/yyyy, HH:mm',
    DATE_TIME_24_WITH_SECONDS: 'MM/dd/yyyy HH:mm:ss',
    DATE_TIME_SHORT_24_WITH_SECONDS: 'MM/dd/yy HH:mm:ss',
    FULL_DATETIME: 'yyyy-MM-ddTHH:mm:ss',
    DATE_FUZZY: 'MMM YYYY',
    DATE_LOCAL: 'l',
    AGE_UNITS: {
      d: 'days',
      w: 'weeks',
      m: 'months',
      y: 'years',
    },
  },
  MAP_PROVIDERS: {
    UNKNOWN: 0,
    GOOGLE: 2, // RNDB has 2 for Google
  },
  DISTANCE: {
    UNIT: {
      MILE: 'M',
      KILO_METER: 'K',
      METER: 'M',
      NAUTICAL_MILE: 'N',
      YARD: 'Y',
    },
    RADIUS_PARAMETER: {
      UNIT_TO_POST: 50,
    },
  },
  WINDOWS: {
    MAP: {
      ID: 'MAP',
      TITLE: 'Map',
      VISIBLE: true,
      ZINDEX: 1000,
    },
    RESOURCES: {
      ID: 'RESOURCES',
      TITLE: 'Resources',
      VISIBLE: true,
      ZINDEX: 1000,
    },
    TRIP_DETAILS: {
      ID: 'TRIP_DETAILS',
      TITLE: 'Trip Details',
      VISIBLE: false,
      ZINDEX: 1001,
    },
    TRIP_ACTIONS: {
      ID: 'TRIP_ACTIONS',
      TITLE: 'Trip Action',
      VISIBLE: false,
      ZINDEX: 1000,
    },
    TRIP_SEARCH: {
      ID: 'TRIP_SEARCH',
      TITLE: 'Trip Search',
      VISIBLE: false,
      ZINDEX: 1000,
    },
    PENDING_ASSIGNMENTS: {
      ID: 'PENDING_ASSIGNMENTS',
      TITLE: 'Pending Assignments',
      VISIBLE: true,
      ZINDEX: 1000,
    },
    CALL_TAKING_EMERGENCY: {
      ID: 'CALL_TAKING_EMERGENCY',
      TITLE: 'Emergency Call Taking',
      VISIBLE: false,
      ZINDEX: 1000,
    },
    CALL_TAKING: {
      ID: 'CALL_TAKING',
      TITLE: 'Call Taking',
      VISIBLE: false,
      ZINDEX: 1000,
    },
    COMPLETED_TRIP: {
      ID: 'COMPLETED_TRIP',
      TITLE: t('callTaking.header.completedTrip'),
      VISIBLE: false,
      ZINDEX: 1000,
    },
    RECURRING: {
      ID: 'RECURRING',
      TITLE: t('callTaking.header.recurring'),
      VISIBLE: false,
      ZINDEX: 1000,
    },
    TRIP_NOTE: {
      ID: 'TRIP_NOTE',
      TITLE: 'Trip Notes',
      VISIBLE: false,
      ZINDEX: 1001,
      NOTE_COUNT: '9+',
    },
    TRIP_HISTORY: {
      ID: 'TRIP_HISTORY',
      TITLE: t('callTaking.history.header'),
      VISIBLE: false,
      ZINDEX: 1001,
    },
    CT_PROQA_SCRIPT: {
      ID: 'CT_PROQA_SCRIPT',
      TITLE: t('callTaking.proqa.script_window_title'),
      VISIBLE: false,
      ZINDEX: 1000,
    },
    TD_PROQA_SCRIPT: {
      ID: 'TD_PROQA_SCRIPT',
      TITLE: t('callTaking.proqa.script_window_title'),
      VISIBLE: false,
      ZINDEX: 1000,
    },
    CALENDAR: {
      ID: 'CALENDAR',
      TITLE: 'Calendar',
      VISIBLE: false,
      ZINDEX: 1000,
    },
    SCHEDULER: {
      ID: 'SCHEDULER',
      TITLE: 'Scheduler',
      VISIBLE: false,
      ZINDEX: 1000,
    },
    ADD_ALERT: {
      ID: 'ADD_ALERT',
      TITLE: 'Add Alert',
      VISIBLE: false,
      ZINDEX: 1000,
    },
    PATIENT: {
      ID: 'PATIENT',
      TITLE: 'Patinet',
      VISIBLE: false,
      ZINDEX: 10002,
    },
    TRANSPORT_REQUEST: {
      ID: 'TRANSPORT_REQUEST',
      TITLE: t('transportRequest.title'),
      VISIBLE: false,
      ZINDEX: 1000,
    },
    TRIP_REQUEST: {
      ID: 'TRIP_REQUEST',
      TITLE: t('transportRequest.header'),
      VISIBLE: false,
      ZINDEX: 1000,
    },
    NOTIFICATION_CENTER: {
      ID: 'NOTIFICATION_CENTER',
      TITLE: t('notificationCenter.title'),
      VISIBLE: false,
      ZINDEX: 1000,
    },
  },
  CREW_MEMBERS: {
    STATUS: {
      INACTIVE: '-1',
      ACTIVE: '1',
    },
  },
};

export const REGEX = {
  PHONE_NUMBER: /^[(][0-9]{3}[)]\s[0-9]{3}-[0-9]{4}(\sExt.\s[0-9]*)|[(][0-9]{3}[)]\s[0-9]{3}-[0-9]{4}$/,
  DATE_FORMAT: /^[0-9]{4}[-][01][0-9]{1}[-][0-9]{2}$/,
  TIME_FORMAT: /^([01][0-9]|2[0-3]):[0-5][0-9]$/,
  UTC_FORMAT: /\d{4}-(0[0-9]|1[0-2])-\d{2}T\d{2}:\d{2}:\d{2}/g,
};

export const CLEAR_ADDRESS_1 = '';

export const NOTIFICATION_FILTERS = [
  { id: 'all', value: t('notificationCenter.filters.all'), label: t('notificationCenter.filters.all') },
  { id: 'unread', value: t('notificationCenter.filters.unread'), label: t('notificationCenter.filters.unread') },
  { id: 'read', value: t('notificationCenter.filters.read'), label: t('notificationCenter.filters.read') },
];

export const TIME_MASK = '__:__';
